import { Label } from "@/components/ui/label";
import { NOTIFICATION_CATEGORIES, type NotificationCategory } from "@/types/api";

const CATEGORY_LABELS: Record<NotificationCategory, string> = {
  auth: "Auth",
  email: "Email",
  network: "Network",
  malware: "Malware",
  data_exfil: "Data Exfil",
  persistence: "Persistence",
  lateral_movement: "Lateral Movement",
  privilege_escalation: "Privilege Escalation",
  cloud: "Cloud",
  endpoint: "Endpoint",
  other: "Other",
};

interface CategoryMultiSelectProps {
  value: NotificationCategory[];
  onChange: (value: NotificationCategory[]) => void;
  id?: string;
}

export function CategoryMultiSelect({ value, onChange, id }: CategoryMultiSelectProps) {
  function toggle(cat: NotificationCategory) {
    if (value.includes(cat)) {
      onChange(value.filter((c) => c !== cat));
    } else {
      onChange([...value, cat]);
    }
  }

  return (
    <div>
      <Label htmlFor={id}>
        Categories <span className="text-xs text-muted-foreground">(empty = all categories)</span>
      </Label>
      <div
        id={id}
        role="group"
        aria-label="Notification categories"
        className="mt-1.5 flex flex-wrap gap-2 rounded-md border border-input bg-background p-2"
      >
        {NOTIFICATION_CATEGORIES.map((cat) => {
          const checked = value.includes(cat);
          return (
            <button
              key={cat}
              type="button"
              role="checkbox"
              aria-checked={checked}
              onClick={() => toggle(cat)}
              onKeyDown={(e) => {
                // ARIA spec for role="checkbox" requires Space to toggle.
                // Enter is supported as a convenience — matches native button
                // expectations on form-like surfaces.
                if (e.key === " " || e.key === "Enter") {
                  e.preventDefault();
                  toggle(cat);
                }
              }}
              className={
                "rounded-full border px-3 py-1 text-xs transition-colors " +
                (checked
                  ? "border-primary bg-primary text-primary-foreground"
                  : "border-input bg-background hover:bg-muted")
              }
            >
              {CATEGORY_LABELS[cat]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
